// eslint-disable-next-line
export default new (class NewsModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.title = data.title || [];
    model.description = data.description || [];
    model.tag = data.tag || [];
    model.slug = data.Slug || "";

    if (
      data.image?.length > 0 &&
      data.image[0]?.image
    ) {
      model.image = data.image[0].image;
    } else {
      model.image = "";
    }

    if (data.content?.length > 0) {
      model.content = data.content;
    } else {
      model.content = [];
    }

    model.createdAt = data.createdAt || "";
    model.publishedAt = data.publishedAt || "";

    return model;
  }
})();
